<script setup lang="ts">
import type { PageTileFragment } from '#graphql-operations'

defineProps<{
  strapiData: PageTileFragment & { PublicationDate?: string, ReadingTime?: number, Tags: { Tag: string }[] }
}>()
</script>

<template>
  <header class="blog-header__header">
    <div
      v-if="strapiData?.Tags?.length"
      class="blog-header__labels"
    >
      <div
        v-for="tag in strapiData.Tags"
        :key="tag.Tag"
        class="blog-header__label"
      >
        {{ tag.Tag }}
      </div>
    </div>

    <UiHeading
      force-tag="h1"
      class="blog-header__title"
    >
      {{ strapiData.PageTitle }}
    </UiHeading>

    <time
      v-if="strapiData?.PublicationDate"
      :datetime="strapiData.PublicationDate"
      class="blog-header__date"
    >
      {{
        $td(new Date(strapiData.PublicationDate), {
          year: 'numeric',
          month: 'long',
          day: 'numeric',
        })
      }}
    </time>
  </header>
</template>

<style>
@import url("~layers/components/Blog/Header.css");
</style>
